import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconRadiusBottomRight12 from './IconRadiusBottomRight12';
import IconRadiusBottomRight16 from './IconRadiusBottomRight16';
import IconRadiusBottomRight20 from './IconRadiusBottomRight20';
import IconRadiusBottomRight24 from './IconRadiusBottomRight24';
import IconRadiusBottomRight32 from './IconRadiusBottomRight32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconRadiusBottomRight = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconRadiusBottomRight12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconRadiusBottomRight16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconRadiusBottomRight20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconRadiusBottomRight24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconRadiusBottomRight32 {...props} />}
        </span>
    );
};
IconRadiusBottomRight.displayName = 'FondueIconRadiusBottomRight';

export default memo(IconRadiusBottomRight);
